export const HOME_CONTENT = {
  ctaSignIn: 'Sign in',
  ctaDashboard: 'Go to Dashboard',
  docsLink: 'Documentation',
  terminalCommand: 'claude-code-command-center',
  headline: 'Multitask across every Claude Code session on all your machines',
  promises: [
    {
      title: 'Monitor & Control',
      body: 'Watch every session unfold in real time and interact directly from your browser',
    },
    {
      title: 'E2E Encryption',
      body: 'Your data stays yours \u2014 encrypted end-to-end with zero-knowledge architecture',
    },
    {
      title: 'Durable State',
      body: 'Every session preserved \u2014 browse, search, and analyze your complete history',
    },
  ],
  quickStart: {
    title: 'Quick start',
    description: 'From scattered to focused in ~10 mins',
    steps: {
      signIn: { title: 'Sign in', time: '~1 min' },
      onboard: { title: 'Onboard', time: '~3 min' },
      install: { title: 'Install', time: '~5 min' },
      launch: { title: 'Launch', time: '~1 min' },
    },
  },
  showcase: {
    title: 'One helm',
    subtitle: 'All battle stations \u00B7 Every mission \u00B7 Any session',
    image: '/images/session_tree.png',
    imageAlt:
      'Session tree showing hosts, projects, and active Claude Code sessions with live status indicators',
  },
  featureHighlights: {
    title: 'Dialed in',
    description: 'Every signal captured, every change delivered when it hits',
  },
  eventIcons: {
    title: 'Clear signal',
    description: 'Distinct shapes per request type \u2014 scan what matters, triage, and act',
  },
  eventNotifications: {
    title: 'Every beat',
    description: 'Watch events flow through the session as they land \u2014 nothing stays hidden',
  },
  liveActivity: {
    title: 'Live wire',
    description: 'Watch the agent work in real time \u2014 every tool call, streaming live',
  },
  sessionModes: {
    title: 'Color coded',
    description: 'Session borders tell you exactly what mode it\u2019s running in',
    cards: [
      {
        title: 'Interactive',
        body: 'Permissions enforced, every action gated \u2014 full control, zero surprises',
      },
      {
        title: 'No guardrails',
        body: 'Permissions bypassed \u2014 the agent runs unrestricted, handle with care',
      },
      {
        title: 'View only',
        body: 'No control channel \u2014 watch the session unfold, but you can\u2019t reach in',
      },
    ],
  },
  agentMode: {
    title: 'Mode aware',
    description: 'Always know which agent mode is running \u2014 no blind spots, no guessing',
  },
  modeControl: {
    title: 'Mode control',
    description: 'Switch agent modes on the fly \u2014 every transition, every level, visible',
  },
  tiles: {
    title: 'Laser focus',
    description: 'Every session\u2019s heartbeat at a glance \u2014 switch context in a snap',
    image: '/images/session_cards.png',
    imageAlt:
      'Event status cards showing bash permissions, plan approvals, agent narratives, and file modifications across sessions',
  },
  notifications: {
    title: 'Heads up',
    description:
      'Stay in the event loop \u2014 blocking events chase you, not the other way around',
    cards: [
      {
        title: 'Sound alerts',
        body: 'Crisp signals for every blocking agent request \u2014 never lose velocity, never miss a beat',
      },
      {
        title: 'Browser push',
        body: 'Native desktop notifications delivered instantly \u2014 stay aware even when eyes are elsewhere',
      },
    ],
  },
  conversation: {
    title: 'On deck',
    subtitle: 'Full thread \u00B7 Complete control \u00B7 Pageable',
    image: '/images/conversation/agent_reply.png',
    imageAlt: 'Conversation view showing code edits and agent interaction',
    accessibilitySummary:
      'Live demo: user requests rate limiting, agent analyzes, asks bash permission, researches, asks questions, proposes plan, creates and edits files, delivers summary.',
  },
  conversationFeatures: {
    title: 'Hooked in',
    description: 'Know what needs you, control the mode, and steer the agent instantly',
  },
  eventDetail: {
    title: 'Spot on',
    description: 'Pull the blocking event out of the stream and give it the focus it deserves',
    image: '/images/agent_plan.png',
    imageAlt:
      'Plan approval dialog showing an OAuth2 PKCE implementation plan with code blocks, tables, and approval options',
  },
  userInput: {
    title: 'Hands on',
    description: 'Reply to the agent, switch modes, and direct execution',
    accessibilitySummary:
      'Demo: user switches from Accept edits to Plan mode, then types a multiline reply asking the agent to design a real-time notification system with WebSocket gateway and priority queue.',
    image: '/images/user_prompt.png',
    imageAlt:
      'Reply to Agent dialog with Plan mode selected, showing a multiline message about designing a real-time notification system',
  },
  drafts: {
    title: 'Inked in',
    description: 'Never lose a thought \u2014 every draft auto saves and syncs across browsers',
  },
  eventInspector: {
    title: 'Drill in',
    description: 'Every event auditable, every detail traceable',
    image: '/images/event_details.png',
    imageAlt:
      'Event details inspector showing event context, end-to-end encryption status, environment, terminal session, and copyable identifiers',
  },
  stateOfPlay: {
    title: 'State of Play',
    description:
      'Blocking events surface instantly \u2014 watch them clear as you choose your response',
  },
  yourCall: {
    title: 'Your call',
    description: 'Pause the agent, inject new instructions, and resume on your own terms',
  },
  terminal: {
    messages: [
      'For Claude Code purists',
      'For control freaks',
      'For getting $h!t done experts',
      'For multithreading human operators',
      'No bull$h!t builders',
      'No voodoo orchestrators',
      'No agents-of-agents circus',
      'Pure Claude Code. Scannable. Beautified.',
    ],
    accessibilitySummary:
      'For Claude Code purists, control freaks, getting done experts, and multithreading human operators. ' +
      'No bullshit builders. No voodoo orchestrators. No agents-of-agents circus. ' +
      'Pure Claude Code. Scannable. Beautified.',
  },
} as const
